import { useQuery } from "react-query"
import { listCategories } from "~/actions/categories"
import { listClients } from "~/actions/clients"
import { listTopics } from "~/actions/docs"
import Autocomplete from "~/components/ReactHookForms/Autocomplete"
import Checkbox from "~/components/ReactHookForms/Checkbox"
import Input from "~/components/ReactHookForms/Input"
import Select from "~/components/ReactHookForms/Select"
import TextArea from "~/components/ReactHookForms/TextArea"
import UploadImage from "~/components/ReactHookForms/UploadImage"
import { DOCS_TYPES } from "~/constants/docs"
import MultiSelect from "../../ReactHookForms/MultiSelect"

const DocDetails = () => {
  const { data: topics } = useQuery("topics", () => listTopics())
  const { data: categories } = useQuery("categories", () => listCategories())
  const { data: clients } = useQuery("clients", () => listClients())

  return (
    <div className="h-full px-8">
      <h3>Doc Details</h3>
      <Input label="Name" id="name" maxLength={255} />
      <TextArea label="Description" id="description" maxLength={2000} />
      <Input label="Path" id="path" maxLength={255} />
      <div className="flex gap-4">
        <Select
          label="Type"
          id="type"
          options={DOCS_TYPES.filter((d) => d.value !== "")}
        />
        <Input
          label="Read Time"
          id="minutes_to_read"
          type="number"
          min={0}
          max={60}
        />
      </div>
      <div className="flex gap-4">
        <Select
          label="Category"
          id="category_id"
          options={categories ? [{ name: "None", id: 0 }, ...categories] : []}
          className="min-h-[32px]"
        />
      </div>
      <div className="flex gap-4">
        <Checkbox label="Hide doc from index page" id="hidden" title="Hidden" />
        <Checkbox label="Show Share Component" id="share" title="Share Doc" />
      </div>
      <Checkbox
        label="Document includes one or more videos"
        id="has_video"
        title="Contains video content"
      />

      <MultiSelect
        label="Clients"
        id="clients"
        options={clients ? [...clients] : []}
        className="min-h-[32px]"
      />
      <Autocomplete
        id="topics"
        label="Topics"
        defaultOptions={topics ?? []}
        placeholder="Type/Select topics related to this doc (press enter to add)"
      />
      <div className="md:w-1/2">
        <UploadImage
          label="Doc Image"
          id="image"
          noCrop={true}
          className="!h-[300px]"
        />
      </div>
    </div>
  )
}

DocDetails.propTypes = {}

export default DocDetails
